import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { Link, Navigate, useParams } from 'react-router-dom';
import { useAuth } from '../../../auth/AuthContext';
import { DemographicsWorkspace } from '../../../components/teams/detailCards/demographics';
import { db } from '../../../firebase-client';
import './demographics.css';

export default function DemographicsPage() {
  const { teamId } = useParams();
  const { user, authLoading } = useAuth();
  const [state, setState] = useState({ loading: true, team: null, isFullAdmin: false, allowed: false, error: '' });

  useEffect(() => {
    let cancelled = false;
    if (authLoading || !user?.uid || !teamId) return () => { cancelled = true; };

    Promise.all([
      getDoc(doc(db, 'teams', teamId)),
      getDoc(doc(db, 'teams', teamId, 'members', user.uid)),
    ]).then(([teamSnap, memberSnap]) => {
      if (cancelled) return;
      if (!teamSnap.exists()) {
        setState({ loading: false, team: null, isFullAdmin: false, allowed: false, error: 'Club not found.' });
        return;
      }
      const team = teamSnap.data() || {};
      const isFullAdmin = Array.isArray(team.admins) && team.admins.includes(user.uid);
      setState({ loading: false, team, isFullAdmin, allowed: isFullAdmin || memberSnap.exists(), error: '' });
    }).catch((error) => {
      if (!cancelled) setState({ loading: false, team: null, isFullAdmin: false, allowed: false, error: error?.message || 'Could not load demographic reporting.' });
    });

    return () => { cancelled = true; };
  }, [authLoading, teamId, user?.uid]);

  if (!authLoading && !user) return <Navigate to="/login" replace />;
  if (authLoading || state.loading) return <main className="demographics-page"><p>Loading demographic reporting…</p></main>;

  const backLink = <Link to={`/teams/${teamId}`}>← Back to {state.team?.name || 'club'}</Link>;
  if (state.error || !state.allowed || state.team?.modules?.demographics?.enabled !== true) {
    return <main className="demographics-page">
      {backLink}
      <section className="demographics-page__empty">
        <h1>Demographic reporting</h1>
        <p>{state.error || (!state.allowed ? 'You need to be a member or full club admin to view this page.' : 'Demographic reporting is not enabled for this club.')}</p>
      </section>
    </main>;
  }

  return <main className="demographics-page">
    <header className="demographics-page__header">
      <div>
        {backLink}
        <h1>{state.isFullAdmin ? 'Demographic reporting' : 'Demographic profile'}</h1>
        <p>{state.isFullAdmin ? 'Collect private responses and review disclosure-protected totals.' : 'Manage the private details used in anonymous club totals.'}</p>
      </div>
    </header>
    <section className="demographics-page__workspace">
      <DemographicsWorkspace teamId={teamId} isFullAdmin={state.isFullAdmin} />
    </section>
  </main>;
}
